import  { useEffect, useState } from 'react';
import { Form, Input, Button,  Typography, notification } from 'antd';
import { getCustomerData, UpdateCustomerInfo } from '../../../store/common/commonAsyncAction';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Loader';

interface Props {
    title?: string;
    data?: any;
}

const ContactInfo = (props: Props) => {
    const [numericError, setNumericError] = useState("")
    const Loading = useSelector((state: any) => state.common.loading);
    const customerData = useSelector((state: any) => state.common.customerData)
    const loginResp = useSelector((state: any) => state.user.userSession);
    const [loading, setloading] = useState(false)
    const [telephone1, setTelephone1] = useState("")
    const [telephone2, setTelephone2] = useState("")
    const [mobileNo, setMobileNo] = useState("")
    const [customerId, setCustomerId] = useState("")

    const dispatch = useDispatch()
    useEffect(() => {
        if (props.data) {

            setCustomerId(props?.data?.id)
            setTelephone1(props?.data?.telephone1)
            setTelephone2(props?.data?.telephone2)
            setMobileNo(props?.data?.mobileNo)

        }
    }, [])
    
    const handleSave = async (formdata: any) => {
        console.log('Success:',);
        // if(/\D/.test(formdata.telephone1)){
        //     setNumericError("only Enter Numeric value in Telephone1 !");
        //     return false;
        // }
        // if(/\D/.test(formdata.telephone2)){
        //     setNumericError("only Enter Numeric value in Telephone2 !");
        //     return false;
        // }
        // if(/\D/.test(formdata.mobileNo)){
        //     setNumericError("only Enter Numeric value in Mobile No !");
        //     return false;
        // }
        // setNumericError("")
        var params = {...customerData};
        setloading(true)
        params.telephone1 = formdata.telephone1;
        params.telephone2 = formdata.telephone2;
        params.mobileNo = formdata.mobileNo;
        if (
            params.telephone1 === customerData.telephone1 &&
            params.telephone2 === customerData.telephone2 &&
            params.mobileNo === customerData.mobileNo
        ) {
            notification.open({
                message: '',
                description:'Profile  Updated Successfully',
               placement:"bottomRight"
              });
            setloading(false)
            return;
       }
        try {
             await dispatch(UpdateCustomerInfo(params))
            const query = `?customerId=${loginResp.userId}&customerEmail=${loginResp.email}`

            await dispatch(getCustomerData(query))
            notification.open({
                message: '',
                description:'Profile  Updated Successfully',
               placement:"bottomRight"
              });
            setloading(false)
        } catch (error) {
            setloading(false)
        }
    }
    const onFinishFailed = () => {
        console.log('Failed:',);
    };

    const { title } = props;
    return (
        <div className="user-profile">
            <Typography.Title className="setting-tab-heading" level={4} >{title} </Typography.Title>
            {
                Loading === true
                    ?
                    <Loader />

                    :
                   <>
                   {/* { numericError && <p className="error-message">{numericError}</p>} */}
                    <Form
                        name="basic"
                        layout="vertical"
                        initialValues={{
                            telephone1:customerData?.telephone1,
                            telephone2: customerData?.telephone2,
                            mobileNo: customerData?.mobileNo

                        }}
                        onFinish={handleSave}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="Telephone 1"
                            name="telephone1"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please input your Telephone 1!',
                                },
                            ]}
                        >
                            <Input placeholder="123312312313" />
                        </Form.Item>

                        <Form.Item
                            label="Telephone 2"
                            name="telephone2"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please input your Telephone 2!',
                                },
                            ]}
                        >
                            <Input placeholder="3123123123" />
                        </Form.Item>
                        <Form.Item
                            label="Mobile No"
                            name="mobileNo"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please input your Mobile No!',
                                },
                            ]}
                        >
                            <Input placeholder="131231231321" />
                        </Form.Item>


                        <Form.Item className="form-btn" >
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                    </>
            }
        </div>
    )
}

export default ContactInfo;